export default (initial = {}) => ({
  ...initial,

  init() {
    Object.keys(initial).forEach((key) =>
      this.$watch(key, () => this.refresh()),
    )
  },

  refresh() {
    const frame = this.$refs.totals
    const tracked = pick(this.$data, Object.keys(initial))

    frame.src = buildPreviewUrl(frame.dataset.base, tracked)
  },
})

const buildPreviewUrl = (base, data) => {
  const params = new URLSearchParams()
  for (const [key, value] of Object.entries(data))
    appendParam(params, key, value)
  const query = params.toString()

  return query ? `${base}?${query}` : base
}

const appendParam = (params, key, value) => {
  if (Array.isArray(value))
    uniqueTruthy(value).forEach((v) => params.append(`${key}[]`, v))
  else if (value !== '' && value != null) params.append(key, value)
}

const uniqueTruthy = (list) => [...new Set(list.filter(Boolean))]

const pick = (object, keys) =>
  Object.fromEntries(keys.map((k) => [k, object[k]]))
